import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
} from 'angular-ts-decorators';

import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from '@fortawesome/pro-solid-svg-icons';
import { Observable } from 'rxjs';

import type { LocalStorage } from '@shared/app/scripts/services/local-storage';
import { Redraw } from '@core/app/scripts/services/redraw';
import { RouteParamsStreams } from '@core/app/scripts/services/route-params-streams';
import { SidebarManager } from '@core/app/scripts/services/sidebar-manager';

/**
 * This component is used to show side bar that is always available on screens wide enough; and
 * collapsed on narrow, mobile devices.
 *
 * # Settings
 * There are two settings necessary for side bar to work as expected. Both are as variables on the
 * scss part:
 * * @sidebarWidth - width of the sidebar
 * * @sidebarThreshold - threshold of the screen width below each sidebar is
 * collapsed, and above it always visible.
 *
 * # Example
 * <pre>
 *   <sidebar></sidebar>
 * </pre>
 */
@Component({
  selector: 'sidebar',
  transclude: true,
  template: require('./sidebar.html').default,
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {
  collapseButton: JQLite;
  isCollapsed: boolean;
  // TODO unit test
  // TODO cypress tests
  noSidebar$: Observable<boolean>;

  faAngleDoubleLeft = faAngleDoubleLeft;
  faAngleDoubleRight = faAngleDoubleRight;

  constructor(
    private $document: ng.IDocumentService,
    private $rootScope: ng.IRootScopeService,
    private $timeout: ng.ITimeoutService,
    private $window: ng.IWindowService,
    private localStorage: LocalStorage,
    private redraw: Redraw,
    private routeParamsStreams: RouteParamsStreams,
    private sidebarManager: SidebarManager,
  ) {
    'ngInject';
  }

  ngOnInit() {
    this.isCollapsed = JSON.parse(
      this.localStorage.getItem('sidebarIsCollapsed'),
    );

    this.sidebarManager.register(this); // TODO: Deregister?

    this.noSidebar$ = this.routeParamsStreams.hasFlag('noSidebar');
  }

  toggleCollapse(isCollapsed) {
    this.isCollapsed = !isCollapsed;
    this.localStorage.setItem(
      'sidebarIsCollapsed',
      JSON.stringify(!isCollapsed),
    );

    this.redraw.forceRedraw();
  }

  ngAfterViewInit() {
    this.$timeout(() => {
      //We grab a reference to the collapse button and add a scroll handler
      this.collapseButton = angular.element(
        this.$document[0].querySelector('.sidebar__collapse'),
      );
      this.$document.on('scroll', () => {
        this.scrollHandler();
      });
    });

    this.$rootScope.$on('$locationChangeStart', () => {
      this.sidebarManager.close();
    });
  }

  ngOnDestroy() {
    this.$document.off('scroll', () => {
      this.scrollHandler();
    });
  }

  // Simple function that keeps the collapseButton on the bottom of the screen based on scrolling.
  // We trade complexity here for simplicity in the CSS and layout of the application.
  private scrollHandler() {
    let scrollHeight = this.$window.scrollY;
    this.collapseButton[0].style.bottom = -1 * scrollHeight + 'px';
  }
}
